<template>
  <div class="header-notification">
    <div class="header-notification__btn btn-style" v-on:click="show = !show">
      <NotificationIco/>
      <div class="header-notification__mail-count"
           v-if="$store.getters.getNotificationsCount > 0"
      >
        {{ $store.getters.getNotificationsCount }}
      </div>
    </div>

    <transition name="fade">
      <div class="header-notification__content" v-if="show || ( show && $store.getters.getOpenNotificationPopup)" v-bind:class="{show: show}">

        <div class="header-notification__close brown-close" v-on:click="show = !show"></div>

        <div class="header-notification__title">
          {{ $t('common_notifications.localization_value.value') }}
        </div>

        <div class="header-notification__all">
          <router-link :to="$store.getters.GET_PATHS.mainSettingsNotifications"
                       class="site-link brown"
                       @click.native="show = false"
          >
            {{ $t('header_viewAll.localization_value.value') }}
          </router-link>
        </div>

        <div class="header-notification__list">

          <div class="header-notification__item"
               v-for="(item, index) in $store.getters.getNotificationsNoRead"
               :key="index"
               @click="viewNotification(item, index)"
               :class="{'deleting' : item.isViewed}"
          >
            <div class="header-notification__name">
              {{item.translationStorage[$store.getters.GET_LANG].title}}
            </div>
            <div class="header-notification__txt">
              {{item.translationStorage[$store.getters.GET_LANG].text}}
            </div>
          </div>

          <!--<div class="header-notification__item">-->
            <!--<div class="header-notification__name">-->
              <!--Orders From Amazon-->
            <!--</div>-->
            <!--<div class="header-notification__txt">-->
              <!--Amazon revetly tightened the rules for using and presenting use data, which led to orders entering the system without a buyer&39’s address. The SkladUSA-->
            <!--</div>-->
          <!--</div>-->

          <!--<div class="header-notification__item">-->
            <!--<div class="header-notification__name">-->
              <!--Added a New Feature-->
            <!--</div>-->
            <!--<div class="header-notification__txt">-->
              <!--From now on, if your ETSY store is connected to our system via API, when creating an order from  PAyPal transactions, if the recepient&s ETSU amd transaction-->
            <!--</div>-->
          <!--</div>-->

          <!--<div class="header-notification__item">-->
            <!--<div class="header-notification__name">-->
              <!--Goods Relocation Function-->
            <!--</div>-->
            <!--<div class="header-notification__txt">-->
              <!--We would like to note that when creating an FBM order from a warehouse in the ISA, if you add a product that is not available the quantity of goods is indicate-->
            <!--</div>-->
          <!--</div>-->

        </div>
      </div>
    </transition>

  </div>
</template>

<script>

  import NotificationIco from '../../../../../../public/img/header/notification.svg?inline'
  export default {
    name: "HeaderNotification",
    components: {
      NotificationIco,
    },

    data() {
      return {
        show: false,
        ifCounter: false
      }
    },

    mounted() {
      document.addEventListener('click', (e) => {
        console.log();
        if(document.querySelector('.header-notification__content.show') !== null){
          if(e.target.closest('.header-notification') === null){
            this.show = false;
          }
        }
      })
    },

    created() {
      this.$store.dispatch('fetchNotificationsNoRead')
      this.$store.dispatch('fetchNotificationsCount')
    },

    methods: {

      viewNotification(item) {
        this.notificationPopup(item.id)
      }
    }

  }
</script>

<style lang="scss">
  @import "./HeaderNotification";
</style>
